import net from '../../utils/net'
export default {
  // 获取导入助手列表
  GetImportInfo (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }
}
